const FIVE_MINUTES_MILLIS = 5 * 60 * 1000;
function key(gameId, number, userId) {
    return `${gameId}:${number}:${userId}`;
}
// Verified daily puzzle results keyed by game + puzzle number + user, with a TTL so a card
// that was "unverified" when first seen is re-checked on a later scroll into view.
function createDailyPuzzleResultsCache() {
    const cache = new Map();
    function expired(entry, now) {
        return now - entry.updated > FIVE_MINUTES_MILLIS;
    }
    return {
        get: (gameId, number, userId, now) => {
            const entry = cache.get(key(gameId, number, userId));
            return entry !== undefined && !expired(entry, now) ? entry : undefined;
        },
        set: (gameId, number, values, now) => {
            for (const [k, entry] of cache) {
                if (expired(entry, now)) {
                    cache.delete(k);
                }
            }
            for (const [userId, result] of values) {
                cache.set(key(gameId, number, userId), { result, updated: now });
            }
        },
    };
}
export const dailyPuzzleResultsCache = createDailyPuzzleResultsCache();
